import { UNIPROMEL_DOMAIN, OPENLEGAL_DOMAIN } from './domains'
import { HEALTHY_HABITS_SUBDOMAIN, INHEALTH_SUBDOMAIN } from './subdomains'

export const OPENSALUD_THEME = 'opensalud'
export const OPENLEGAL_THEME = 'openlegal'
export const UNIPROMEL_THEME = 'unipromel'
export const HEALTHY_HABITS_THEME = 'healthy-habits'
export const INHEALTH_THEME = 'inhealth'

export function getThemeName () {
    const hostname = window.location.hostname

    if (hostname.includes(UNIPROMEL_DOMAIN)) {
        return UNIPROMEL_THEME
    } else if (hostname.includes(HEALTHY_HABITS_SUBDOMAIN)) {
        return HEALTHY_HABITS_THEME
		} else if (hostname.includes(INHEALTH_SUBDOMAIN)) {
				return INHEALTH_THEME
    } else if (hostname.includes(OPENLEGAL_DOMAIN)) {
        return OPENLEGAL_THEME
    } else {
        return OPENSALUD_THEME
    }
}


// WEBPACK FOOTER //
// ./src/constants/themes.js